// ABOUTME: CSS custom properties derived from the active theme, for plain .css files that
// ABOUTME: have no JS access to theme.ts/tokens.ts (see AvatarUploadModal.css, index.css)
import type { CSSObject, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { neutralGray, errorTint, statusTint, behaviorButtonContrastText, celebrationGold, celebrationGoldHover } from './tokens';

export const getThemeCssVariables = (theme: Theme): CSSObject => ({
  ':root': {
    '--color-error-main': theme.palette.error.main,
    '--color-error-light': theme.palette.error.light,
    '--color-error-dark': theme.palette.error.dark,
    '--color-error-tint-50': errorTint[50],
    '--color-error-tint-200': errorTint[200],
    '--color-error-tint-800': errorTint[800],
    '--color-info-main': theme.palette.info.main,
    '--color-info-dark': theme.palette.info.dark,
    '--color-info-tint-50': statusTint.infoBg,
    '--color-success-main': theme.palette.success.main,
    '--color-success-light': theme.palette.success.light,
    '--color-success-dark': theme.palette.success.dark,
    '--color-warning-main': theme.palette.warning.main,
    '--color-warning-dark': theme.palette.warning.dark,
    '--color-gray-50': neutralGray[50],
    '--color-gray-100': neutralGray[100],
    '--color-gray-200': neutralGray[200],
    '--color-gray-300': neutralGray[300],
    '--color-gray-400': neutralGray[400],
    '--color-gray-500': neutralGray[500],
    '--color-gray-600': neutralGray[600],
    '--color-gray-700': neutralGray[700],
    '--color-gray-800': neutralGray[800],
    '--color-gray-900': neutralGray[900],
    '--color-behavior-star-text': behaviorButtonContrastText.star,
    '--color-behavior-triangle-text': behaviorButtonContrastText.triangle,
    '--color-behavior-square-text': behaviorButtonContrastText.square,
    '--color-celebration-gold': celebrationGold,
    '--color-celebration-gold-hover': celebrationGoldHover,
    // Pure-black alpha overlays/shadows, for plain CSS files with no access to alpha()
    '--color-black-04': alpha(theme.palette.common.black, 0.04),
    '--color-black-05': alpha(theme.palette.common.black, 0.05),
    '--color-black-10': alpha(theme.palette.common.black, 0.1),
    '--color-black-50': alpha(theme.palette.common.black, 0.5),
  },
});
